/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import Tippy from '@tippyjs/react';
import * as React from 'react';
import {
  components as SelectComponents,
  GroupTypeBase,
  OptionTypeBase,
  SingleValueProps,
  StylesConfig,
} from 'react-select';

import { userSelectStyles } from './user';

const days = [...Array(31).keys()].map((i) => i + 1);

export const DaysOfTheMonthLabels = (day: string) => {
  if (day === 'last') {
    return <Tippy content="Last" />;
  } else {
    return <Tippy content={parseInt(day, 10) < 10 ? `0${day}` : day} />;
  }
};

export const renderDayOfTheMonth = (day: string) => {
  return DaysOfTheMonthLabels(day);
};

export const dayOfTheMonthOptions = () => {
  const daysList: { label: string; value: string }[] = [];
  days.forEach((day) => {
    daysList.push({
      label: day < 10 ? `0${day.toString(10)}`.toString() : day.toString(10),
      value: day.toString(),
    });
  });
  daysList.push({ label: 'Last', value: 'last' });
  return daysList;
};

export const getDayOfTheMonthLabel = (day: string) => {
  if (day === 'last') {
    return 'Last';
  } else {
    return dayOfTheMonthOptions()[parseInt(day, 10) - 1].label;
  }
};

type OptionType = OptionTypeBase & { label: string; value: string };
type GroupType = GroupTypeBase<OptionType>;

export const dayOfTheMonthSelectStyles: StylesConfig<OptionType, boolean, GroupType> = {
  ...userSelectStyles,
  menuPortal: (base) => ({ ...base, zIndex: 1600 }),
  option: (styles, { isDisabled, isFocused, isSelected }) => ({
    ...styles,
    ...(userSelectStyles?.option
      ? userSelectStyles?.option(styles, {
          isDisabled: isDisabled,
          isFocused: isFocused,
          isSelected: isSelected,
        } as any)
      : {}),
    padding: '1.3rem 1.5rem 1.3rem 1rem',
  }),
};

export const DayOfTheMonthSelectSingleValue:
  | React.ComponentType<SingleValueProps<OptionType, GroupType>>
  | undefined = (props) => (
  <div className="flex items-center">
    {/* {props.data.value} */}
    {renderDayOfTheMonth(props.data.value)}
    <span className="ml-8">{props.data.label}</span>
  </div>
);

export const DayOfTheMonthSelectOption: any = (props) => (
  <SelectComponents.Option {...props}>
    <div className="flex items-center">
      {/* {props.data.value} */}
      {renderDayOfTheMonth(props.data.value)}
      <span className="ml-8">{props.data.label}</span>
    </div>
  </SelectComponents.Option>
);
